export const USER_DETAILS = 'USER_DETAILS';
export const USER_DETAILS_FAILURE = 'USER_DETAILS_FAILURE';
export const USER_INVITED = 'USER_INVITED';
export const SIGNUP_USERSESSION = 'SIGNUP_USERSESSION';

export const SM_DATA_RESET = 'SM_DATA_RESET';
export const SM_DATA_SUCCESS = 'SM_DATA_SUCCESS';
export const SM_DATA_FAILURE = 'SM_DATA_FAILURE';
export const SKIP_MAILBOX_CREATION = 'SKIP_MAILBOX_CREATION';

export const UG_CREATE_SUCCESS = 'UG_CREATE_SUCCESS';
export const UG_CREATE_FAILURE = 'UG_CREATE_FAILURE';
export const UG_ERROR_RESET = 'UG_ERROR_RESET';

export const resetSmData = () => ({ type: SM_DATA_RESET });
